import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CreateContent from "../../pages/createContent";
import { Button, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import UploadEpisodes from "./UploadEpisodes";
import CSVUploader from "./CSVUploader";
import { useState } from "react";
import RenderCSVTable from "./CSVTable";
import { useDispatch, useSelector } from "react-redux";
import { setCSVBatchData } from "../../redux/slices/contentSlice/contentForm/contentForm";
import ViewCSVData from "./ViewCSVData";

export default function UploadSeasonContent({ title, seasonId }) {
  const dispatch = useDispatch();
  const csvBatchData = useSelector((state) => state.contentForm.csvBatchData);
  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {title}
        </AccordionSummary>
        <AccordionDetails>
          {/* <Typography>Upload Your Episodic Data</Typography> */}
          {/* <Box>
            {csvBatchData && csvBatchData.length > 0 ? (
              <ViewCSVData csvData={csvBatchData} />
            ) : (
              <CSVUploader
                onFileLoad={(data) => dispatch(setCSVBatchData(data))}
              />
            )}
          </Box> */}
          <UploadEpisodes seasonId={seasonId} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
